var __jsx = React.createElement;
import React, { useState } from 'react';
import AuthFormTemplate from '../../../../templates/auth-form.template';
import { useTranslations } from 'next-intl';
import MuscleSelectInput from '@modules/shared/components/select-input';
import MuscleFormTextInput from '@modules/shared/components/form-text-input';
import { MuscleButton } from '@modules/shared/components/buttons';
import customersManager from '@lib/data/managers/shared/customers-manager';
import { useMediaQuery } from 'react-responsive';
import useViewportDimensions from '@lib/hooks/use-viewport-dimensions';
import { BREAKPOINTS } from '@lib/constants';
const CustomerRegisterForm = _ref => {
  let {
    onSuccessValidatingId,
    onErrorValidatingId
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const idTypeOptions = [{
    key: '1',
    value: t('NATIONAL_ID')
  }, {
    key: '2',
    value: t('PASSPORT')
  }];
  const {
    0: selectedIdType,
    1: setSelectedIdType
  } = useState('');
  const {
    0: idNumber,
    1: setIdNumber
  } = useState('');
  const {
    0: isValidatingId,
    1: setIsValidatingId
  } = useState(false);
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    height,
    width
  } = useViewportDimensions(0.8, isMobile ? 0.7 : 0.8);
  const validateId = async () => {
    setIsValidatingId(true);
    const validationResponse = await customersManager.validateIdentificationForRegistration(selectedIdType, idNumber);
    setIsValidatingId(false);
    if ('email' in validationResponse) {
      onSuccessValidatingId(validationResponse.email, selectedIdType, idNumber);
    } else {
      onErrorValidatingId(validationResponse.code);
    }
  };
  return __jsx(AuthFormTemplate, null, __jsx("div", {
    className: "flex flex-col gap-8",
    style: {
      width: isMobile ? width : '384px'
    }
  }, __jsx("div", {
    className: "flex flex-col items-center justify-center gap-2"
  }, __jsx("div", {
    className: "text-center text-neutral-600 tx-plg-bold"
  }, t('REGISTER_TITLE')), __jsx("div", {
    className: "text-center text-neutral-600 tx-psm-regular"
  }, t('REGISTER_LEGEND'))), __jsx(MuscleSelectInput, {
    dataTestId: "register-id-type-select",
    label: t('IDENTIFICATION_TYPE'),
    options: idTypeOptions,
    onSelectOption: option => setSelectedIdType(option.key),
    optionClassName: "tx-psm-regular",
    inlineModeConfiguration: {
      labelClassname: 'tx-psm-bold'
    }
  }), selectedIdType !== '' ? __jsx(React.Fragment, null, __jsx(MuscleFormTextInput, {
    dataTestId: "register-id-number-input",
    label: t('IDENTIFICATION_NUMBER'),
    placeholder: t('IDENTIFICATION_NUMBER'),
    onChangeValue: value => setIdNumber(value),
    fullLength: true,
    labelClassName: "tx-psm-bold"
  })) : null, __jsx("div", null), __jsx("div", {
    className: "flex flex-row gap-2 w-full justify-center"
  }, __jsx(MuscleButton, {
    dataTestId: "register-continue-button",
    variant: "solidMd",
    disabled: selectedIdType === '' || idNumber === '',
    onClick: validateId,
    isLoading: isValidatingId
  }, t('CONTINUE')))));
};
export default CustomerRegisterForm;